import React from 'react';
import { StyledBody, StyledInput, StyledLabel } from './ModernRadioOption.styled';
export default function ModernRadioOption({
  name,
  value,
  checked,
  disabled,
  testid,
  onChange,
  children,
  variant = 'branding',
}) {
  const id = `${name}-${value}`;

  return (
    <StyledLabel htmlFor={id} data-testid={testid || id} variant={variant}>
      <StyledInput
        type="radio"
        name={name}
        value={value}
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        role="radio"
      />
      <StyledBody variant={variant}>
        <span className="w-full flex flex-col h-full">{children}</span>
      </StyledBody>
    </StyledLabel>
  );
}
